export default function CellEaterIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#12485A" />
      <path d="M2 18h60M2 34h60M2 50h60M18 2v60M34 2v60M50 2v60" stroke="#2A6A7E" strokeWidth="1.5" />
      <circle cx="10" cy="12" r="3" fill="#FFB020" />
      <circle cx="54" cy="10" r="3" fill="#FF6BD6" />
      <circle cx="12" cy="54" r="3" fill="#5CE07A" />
      <path d="M47 34l2 4 4-1-1 4 4 2-4 2 1 4-4-1-2 4-2-4-4 1 1-4-4-2 4-2-1-4 4 1z" fill="#B05BE0" />
      <circle cx="47" cy="44" r="5.5" fill="#D27BFF" stroke="#7A2FB0" strokeWidth="1.5" />
      <circle cx="27" cy="29" r="19" fill="#2C7FD9" />
      <circle cx="27" cy="29" r="16.5" fill="#4FA8FF" />
      <ellipse cx="21" cy="22" rx="5" ry="3" fill="#fff" opacity=".35" transform="rotate(-30 21 22)" />
      <circle cx="21.5" cy="28" r="3" fill="#fff" />
      <circle cx="32.5" cy="28" r="3" fill="#fff" />
      <circle cx="22.3" cy="28.5" r="1.5" fill="#14213D" />
      <circle cx="33.3" cy="28.5" r="1.5" fill="#14213D" />
      <path d="M21 35c3 3 9 3 12 0" stroke="#14213D" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="49" cy="22" r="6" fill="#FF5D73" />
    </svg>
  );
}
